import { InlineText1, InlineText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as style from './NoTourSupport.css';

export const NoTourSupport = () => {
  return (
    <div className={style['container']}>
      <div className={style['icon']} />
      <InlineText1 fontWeight={'bold'}>Ваш браузер не поддерживает 3D-тур</InlineText1>
      <div className={style['text']}>
        <InlineText2 color={'black_60'}>
          Установите последнюю версию Google Chrome или воспользуйтесь любым другим браузером
        </InlineText2>
      </div>
    </div>
  );
};

NoTourSupport.displayName = 'NoTourSupport';
